import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import getTotalDbApiChecksByTariffPeriod from '../../resolvers/getTotalDbApiChecksByTariffPeriod';
import getAccountBonusByPeriod from '../../resolvers/getAccountBonusByPeriod';
import { pageLoading, promoCodesListSelector } from '../../redux/selectors/pagesSelectors';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import { getPromoFromArray } from '../../utils';
import useTotalSum from '../../hooks/useTotalSum';
import { cartMainProduct } from '../../redux/selectors/cartSelector';
import useTotalDiscountPromo from '../../hooks/useTotalDiscountPromo';

function TableFooter({ product, discount, boltPrice, pageLoading, promoCodesList, mainProduct }) {
    // dbChecks will be calculated only for productId = 2 (DB API).
    const dbChecks = getTotalDbApiChecksByTariffPeriod(product);
    const [licenseValidTill, setLicenseValidTill] = useState(null);
    const [showPromo, setShowPromo] = useState(false);
    const [promo, setPromo] = useState({});
    const totalSum = useTotalSum(mainProduct?.product_id);
    const productDiscountPromo = useTotalDiscountPromo(mainProduct?.product_id, promo);

    const bonus = useMemo(() => {
        if (product?.period && product?.tariff) {
            return product?.period?.interval_bonus
                ? product?.period
                : Object.values(product?.tariff?.periods).find(
                      (item) =>
                          item.interval === product?.period?.billing_period &&
                          item.interval_count === product?.period?.interval
                  );
        }
    }, [product?.period, product?.tariff]);

    const bonusPeriod = useMemo(() => {
        if (bonus) {
            const bonusPeriodStructure = getAccountBonusByPeriod(bonus);
            if (bonusPeriodStructure) {
                return bonusPeriodStructure;
            }
        }
    }, [bonus]);

    useEffect(() => {
        if (product?.period?.license_valid_till) {
            setLicenseValidTill(moment(product?.period?.license_valid_till).format('MMM DD YYYY'));
        } else if (product?.tariff?.periods) {
            setLicenseValidTill(
                moment(bonusPeriod ? bonusPeriod?.license_valid_till : bonus?.license_valid_till)
                    // .add(product?.period?.interval, product?.period?.billing_period)
                    .format('MMM DD YYYY')
            );
        }
    }, [product?.period, product?.tariff, bonusPeriod, bonus]);

    useEffect(() => {
        if (promo && +promo?.product_id === +mainProduct?.product_id) {
            setShowPromo(true);
        } else {
            setShowPromo(false);
        }
    }, [promo, mainProduct]);

    useEffect(() => {
        setPromo(getPromoFromArray(promoCodesList));
    }, [promoCodesList]);

    return (
        <div className={'section__row section__row--border-top'}>
            <div className={'section__cell section__cell--name'}>
                {dbChecks > 0 && (
                    <p className={'text-3 mb-16 flex flex--column'}>
                        <span>Total available {dbChecks} checks</span>
                        <span className={'text-4 pt-2 color--gray'}>
                            Block Lists Licenses stop working when any threshold is exceeded — either the number of spam checks drops to zero or the license time period ends. The number of checks can be transferred to a new license if the old license is still active, otherwise the remaining checks get nullified.
                        </span>
                    </p>
                )}

                {pageLoading ? (
                    <Skeleton width={200} count={2} containerClassName={'mb-13'} />
                ) : (
                    <>
                        <p className={'text-3 mb-13'}>
                            <span className={'underline--no-hover'}>
                                License period&nbsp;{moment().format('MMM DD YYYY')} -{' '}
                                {licenseValidTill}
                            </span>
                        </p>

                        {bonusPeriod && (
                            <p className={'text color--green'}>
                                Make your payment before{' '}
                                {moment(product?.valid_till).format('MMM DD YYYY')} and get{' '}
                                {bonusPeriod?.label} for free.
                            </p>
                        )}
                    </>
                )}
            </div>
            <div className={'section__cell section__cell--total'}>
                <div className={'flex flex--space-between'}>
                    <span className={'text-3'}>Total discount</span>
                    <span className={'text-3'}>
                        {pageLoading ? <Skeleton width={100} /> : discount}
                    </span>
                </div>
                {showPromo && (
                    <div className={'flex flex--space-between mt-10'}>
                        <span className={'text-3'}>Promo code discount</span>
                        <span className={'text-3'}>
                            {pageLoading ? <Skeleton width={100} /> : <>{productDiscountPromo}</>}
                        </span>
                    </div>
                )}
                <div className={'flex flex--space-between mt-10'}>
                    <span className={'text-3'}>Price</span>
                    <span className={`text-3 ${boltPrice ? 'bold' : ''}`}>
                        {pageLoading ? <Skeleton width={50} /> : totalSum}
                    </span>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    pageLoading: pageLoading(state),
    promoCodesList: promoCodesListSelector(state),
    mainProduct: cartMainProduct(state),
});

export default connect(mapStateToProps, null)(TableFooter);
